import { Autocomplete, Chip, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useMemo } from 'react';

import { HourlyAccountUserGroupZonePromoCode } from '../../types';

interface ZonePromoCodeSelectProps {
	editing: boolean;
	value: HourlyAccountUserGroupZonePromoCode[];
	options: HourlyAccountUserGroupZonePromoCode[];
	onChange: (e, value) => void;
}
export const ZonePromoCodeSelect = ({ editing, value, options, onChange }: ZonePromoCodeSelectProps) => {
	const filteredOptions = useMemo(
		() =>
			options.map((option) => ({
				...option,
				id: null,
			})),
		[options],
	);

	if (editing) {
		return (
			<Autocomplete
				options={filteredOptions}
				value={value}
				multiple
				size='small'
				sx={{ width: '100%' }}
				filterSelectedOptions
				isOptionEqualToValue={(option, val) => option.zonePromoCode.id === val.zonePromoCode.id}
				getOptionLabel={(option) =>
					`${option.zonePromoCode.facilityZone.name} - ${option.zonePromoCode.promoCode.text}`
				}
				getOptionKey={(option) => option.zonePromoCode.id}
				renderInput={(params) => (
					<TextField
						{...params}
						variant='standard'
						placeholder=''
						InputProps={{
							...params.InputProps,
							sx: {
								minHeight: '40px',
								'& .MuiAutocomplete-clearIndicator': {
									display: 'none',
								},
								'&::before': {
									borderBottom: 'none !important',
								},
								'&::after': {
									borderBottom: 'none !important',
								},
							},
						}}
					/>
				)}
				onChange={onChange}
			/>
		);
	}

	return (
		<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, my: 1 }}>
			{value.map(
				({
					zonePromoCode: {
						id,
						promoCode: { text },
						facilityZone: { name: zoneName },
					},
				}) => (
					<Chip key={id} label={`${zoneName} - ${text}`} size='small' />
				),
			)}
		</Box>
	);
};
